import { render, staticRenderFns } from "./CarrierDestination.vue?vue&type=template&id=12f81dea&scoped=true&"
import script from "./CarrierDestination.vue?vue&type=script&lang=js&"
export * from "./CarrierDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f81dea",
  null
  
)

export default component.exports